module.exports = __webpack_public_path__ + "img/ind_chem.710110b3.png";